export default __webpack_public_path__ + "static/media/code-icon-blue.b1319b43.svg";